import { useTranslation } from "react-i18next";
import { useDOCOnlineContext } from "./DOCOnlineContext";
import IconCheck from "../../layout/others/icon_done_success_check.svg";
import "./DOCOnline.scss";

const DOCOnlineSuccessPage = () => {
  const { t } = useTranslation();
  const { currentStep, docOnline } = useDOCOnlineContext();

  if (currentStep !== 7) {
    return null;
  }

  const candidateName = docOnline.personalInformation.fullName;

  return (
    <section className="step">
      <div className="card doc-inboard p-3 success-footer-doconline">
        <div className="success-page">
          <div className="success-text">
            <img src={IconCheck} alt="success" />
            <h1>{t("Thanks for sending your online curriculum!")}</h1>
          </div>
          <div className="success-doc-content">
            <p>
              <span>{candidateName}</span>,{" "}
              {t("your online curriculum was successfully sent.")}
            </p>
            {!docOnline.isConsultant && (
              <p>
                {t(
                  "Please wait for the contact from one of our recruiting team members!"
                )}
              </p>
            )}

            <br />
            <p>
              <strong>{t("Reach us by phone")}:</strong>{" "}
              {docOnline.companyPhoneNumber}
            </p>
            <p>
              <strong>{t("Or by mail")}:</strong>{" "}
              {docOnline.companyEmailAddress}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DOCOnlineSuccessPage;
